var exports = {
  "nV": "xdbfd91f1--b5494f--gallery",
  "kY": "xdbfd91f1--b5494f--transition",
  "gV": "xdbfd91f1--b5494f--slider_wrapper",
};

module.exports = exports;
